module.exports = __webpack_public_path__ + "static/media/studying-girl.4085c1e8.svg";